import React from 'react'
import PropTypes from 'prop-types'
import { propType } from 'graphql-anywhere'
import TILE_FRAGMENT from '../../../graphql/fragments/tile.gql'

import Fader from './fader/fader'
import Slide from './slide/slide'

function TileSlide({ tiles, handleChange }) {
  if (!tiles || !tiles.length) {
    return null
  }

  const rentalInfo = tiles.map(tile => tile.contentItem.isRental)
  const tileSlideInterval = 7000

  return (
    <Fader interval={tileSlideInterval} rentalInfo={rentalInfo} handleChange={handleChange}>
      {
        tiles.map((tile, index) => (
          <Slide
            tile={tile}
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            hasBottomGradient={tiles.length > 1}
          />
        ))
      }
    </Fader>
  )
}

TileSlide.propTypes = {
  tiles: PropTypes.arrayOf(propType(TILE_FRAGMENT)).isRequired,
  handleChange: PropTypes.func
}

TileSlide.defaultProps = {
  handleChange: null
}

export default TileSlide
